import cx from "classnames";
import { forwardRef } from "react";
import styles from "./ResultRowWrapper.module.css";

import type { KeyboardEvent, MouseEvent, ReactNode } from "react";

export interface ResultRowWrapperProps {
  isSelected?: boolean;
  isFocused?: boolean;
  isMouseActive?: boolean;
  resultRowIndex?: number;
  onClick?: (e: MouseEvent<HTMLLIElement>) => void;
  setIsHovered?: () => void;
  setIsUnhovered?: () => void;
  children: ReactNode;
  uuid: string;
}

export const ResultRowWrapper = forwardRef<
  HTMLLIElement,
  ResultRowWrapperProps
>(
  (
    {
      isSelected = false,
      isFocused = false,
      isMouseActive = true,
      resultRowIndex,
      onClick,
      setIsHovered,
      setIsUnhovered,
      uuid,
      children,
    },
    ref,
  ) => {
    const handleClick = (e: MouseEvent<HTMLLIElement>) => {
      onClick?.(e);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLLIElement>) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick?.(e as unknown as MouseEvent<HTMLLIElement>);
      }
    };

    return (
      <li
        className={cx(
          styles.resultRowWrapper,
          {
            [styles.isSelected]: isSelected || isFocused,
            [styles.mouseActive]: isMouseActive,
          },
          "meticulous-redact-recording",
        )}
        onClick={handleClick}
        ref={ref}
        onKeyDown={handleKeyDown}
        onMouseEnter={() => setIsHovered?.()}
        onMouseLeave={() => setIsUnhovered?.()}
        role="option"
        id={
          resultRowIndex !== undefined
            ? `typeahead-option-${resultRowIndex}`
            : undefined
        }
        data-x-uuid={uuid}
        aria-selected={isSelected}
        tabIndex={0}
      >
        {children}
      </li>
    );
  },
);

ResultRowWrapper.displayName = "ResultRowWrapper";
